import React from "react";

const NativeBanner = () => {
  return (
    <div className="mt-8 z-0">
      <div className="text-gray-400 text-center  text-xs font-bold">
        Advertisements
      </div>
      <div
        className="text-white"
        id="container-f723cf9a1807ae2af724c89b41ea6226"
      ></div>
    </div>
  );
};

export default NativeBanner;
